import WildAppResource from "./WildAppResource";
import Engine from 'ss-js-engine';
import {flattenKeys} from "ss-js-engine/src/Helpers/Misc/objectHelpers";

class ActivityLogAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'activity-log';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'activities/logs';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'id',
            'deleted_at',
            'created_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'log_name',
            'description',
            'subject',
            'subject_type',
            'subject_id',
            'causer',
            'causer_type',
            'causer_id',
            'properties',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            subject: WildAppResource,
            causer: WildAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            log_name: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            subject: {
                type: 'object',
            },
            causer: {
                type: 'object',
            },
            properties: {
                presence: true,
            },
            'properties.attributes': {
                type: 'array',
            },
            'properties.old': {
                type: 'array',
            },
        }
    }

    /**
     * @returns {{elasticsearch: *, search: *, restore: *, fetch: *, create: *, update: *, delete: *}}
     */
    apiPaths () {
        return {
            'elasticsearch': Engine.apiUrl(this.appResourceApiPrefix()) + '/e-search',
            ...super.apiPaths(),
        }
    }
}

export default ActivityLogAppResource;
